export class Authentication {
    Email:string;
    Password:string;
}
